import React from 'react';

import './Affilation.css';

const data = [
  { id: 1, title: 'Pt. L.R school of pharmacy faridabad', download: '/Affiliation/Pt. LR school of pharmacy faridabad.pdf' },
  { id: 1, title: 'PCI (Pharmacy Council of India)', download: '/Affiliation/Ptlrsph PCI Decision Letter 2024-25.pdf' },
  
  ];

const Affiliation = () => {
  return (
    <div className="main-container-affiliation">
     
      <div className="container-affiliation1">
        <div
          data-aos="flip-up"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        >
          <h1>AFFILIATION</h1> <br /> 
          <div className="table-wrapper">
            <table className="fl-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Title</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.title}</td>
                    <td>
                      <a
                        href={item.download}
                        download={item.download}
                        className="primary-button"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Affiliation;
